module.exports = __webpack_public_path__ + "img/06_Linear_Schieben_VFT@2x.9c37f9c1.jpg";